import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "./pages/Landing";
import ProgramDetail from "./pages/ProgramDetail";
import InstructorSignup from "./pages/InstructorSignup";

const TOAST_OPTIONS = {
  style: {
    background: "#FFFFFF",
    color: "#1A1620",
    border: "1px solid rgba(26,22,32,0.1)",
    borderRadius: "2px",
  },
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/programs/:slug" element={<ProgramDetail />} />
          <Route path="/teach" element={<InstructorSignup />} />
          <Route path="/instructors" element={<InstructorSignup />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="light"
        position="bottom-right"
        toastOptions={TOAST_OPTIONS}
      />
    </div>
  );
}

export default App;
